module.exports = __webpack_public_path__ + "img/08eeb56c1f8d92c285449e5918afc89b.6c47780a.jpeg";